var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stacktrace"},_vm._l((_vm.entries),function(entry,index){return _c('stack-trace-entry',{key:`stacktrace-entry-${index}`,attrs:{"lines":entry.context,"file-path":entry.filename || entry.abs_path,"error-line":entry.lineNo,"error-fn":entry.function,"error-column":entry.colNo,"expanded":_vm.isFirstEntry(index)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }